/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, amount: NonNullable<unknown> }} Equivalence_BusInputs */

const en_us2_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`the weight of a bus`);
	return /** @type {LocalizedString} */ (`the weight of ${i?.amount} buses`)
	
};

const pt_br2_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um ônibus`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} ônibus`)
	
};

const es_419_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`el peso de un autobús`);
	return /** @type {LocalizedString} */ (`el peso de ${i?.amount} autobuses`)
	
};

const pt_pt2_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`o peso de um autocarro`);
	return /** @type {LocalizedString} */ (`o peso de ${i?.amount} autocarros`)
	
};

const fr_fr2_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`le poids d'un bus`);
	return /** @type {LocalizedString} */ (`le poids de ${i?.amount} bus`)
	
};

const de_de2_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`das Gewicht eines Busses`);
	return /** @type {LocalizedString} */ (`das Gewicht von ${i?.amount} Bussen`)
	
};

const it_it2_equivalence_bus = /** @type {(inputs: Equivalence_BusInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`il peso di un autobus`);
	return /** @type {LocalizedString} */ (`il peso di ${i?.amount} autobus`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "the weight of a bus" |
* | * | "the weight of {amount} buses" |
*
* @param {Equivalence_BusInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const equivalence_bus = /** @type {((inputs: Equivalence_BusInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Equivalence_BusInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_equivalence_bus(inputs)
	if (locale === "es-419") return es_419_equivalence_bus(inputs)
	if (locale === "pt-PT") return pt_pt2_equivalence_bus(inputs)
	if (locale === "fr-FR") return fr_fr2_equivalence_bus(inputs)
	if (locale === "de-DE") return de_de2_equivalence_bus(inputs)
	if (locale === "it-IT") return it_it2_equivalence_bus(inputs)
	return en_us2_equivalence_bus(inputs)
});
export { equivalence_bus as "equivalence.bus" }